<template>
    <v-dialog
        :value="value"
        :v-bind="$attrs"
        v-on="$listeners"
        persistent
        width="300"
    >
        <v-card
            color="secondary"
            dark
        >
            <v-card-text class="pa-3">
                {{ message }}
                <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-3"
                ></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script >
export default {
    props: ['message', 'value'],
}
</script>